// extracted by mini-css-extract-plugin
export default {"legendContainer":"Legend_legendContainer__wtpU6","legendColumn":"Legend_legendColumn__mPh7n","legendItem":"Legend_legendItem__mnOOD"};